import { render } from "./Parametros.vue?vue&type=template&id=70800499"
import script from "./Parametros.vue?vue&type=script&lang=js"
export * from "./Parametros.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__